import { Edit, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditDoctoralSeat = () => {
  return (
    <Edit
      title="Редакция на докторантско място"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditDoctoralSeat;
